import { dinero, toFormat } from "dinero.js";
import * as CURR from "@dinero.js/currencies";
import _ from "lodash";

const transformer = (props: any) => `${props.amount}`;

export function format(dineroObject: any) {
  return toFormat(dineroObject, transformer);
}

export function FromSmallestUnit(amount: number, currency: string) {
  const t = CURR[currency as keyof typeof CURR];
  if (!t) return null;

  const dineroObject = dinero({ amount, currency: t });
  return Number(format(dineroObject)).toFixed(2);
}

// FIXME: wont work with all currencies
export const minorNumberToCurrencyNumber = function (amount: number) {
  if (amount) {
    const amountNumber = _.toNumber(amount);
    return (amountNumber * 0.01).toFixed(2);
  }
  return amount;
};

export function PrettifyPrice(price: number, currency: string, roundingFn?: (value: number) => number) {
  if (isNaN(price) || !currency) {
    return null;
  }
  const formattedPrice = FromSmallestUnit(price, currency);
  const roundedPrice = roundingFn ? roundingFn(Number(formattedPrice)) : Number(formattedPrice);

  // `Intl.NumberFormat` to get just the symbol for the currency
  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: roundingFn ? 0 : 2,
    maximumFractionDigits: 2,
    currencyDisplay: "narrowSymbol",
  });
  const amountWithSign = currencyFormatter.format(Number(roundedPrice)); // Pass any number (0 is fine, we just want the symbol)

  return amountWithSign;
}
